/**
 * 封装Axios
 * 处理请求、响应错误信息
 */
import { Message } from 'element-ui'  //引用饿了么UI消息组件
import axios from 'axios' //引用axios

const product = 'https://api.kaoyanbox.com' //正式
const pre = 'http://pre-api.kaoyanbox.net'
const daily = 'https://test-api.kaoyanbox.net'  //测试

let host = daily
// 环境判断
if (location) {
  if (location.host.includes('admin.kaoyanbox.com')) {
    host = product
  } else if (location.host.includes('admin.kaoyanbox.net')) {
    host = pre
    if (location.host.includes('test')) {
      host = daily
    }
  }
} 
// 本地开发环境
if (process.env.NODE_ENV === 'development') {
  // host = 'http://127.0.0.1:7001'
}

// create an axios instance
const service = axios.create({
  baseURL: host,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
  	// console.log('config:', config)
    let adminToken = localStorage.getItem('admin_token')
    /*    if (adminToken) {
         config.headers.Authorization = `${adminToken}`
       } */
    adminToken && (config.headers.Authorization = adminToken)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.status === 200) {
      const res = response.data //res is my own data
      if (res.code === 0) {
        return res.data
      } else {
        if (res.code === 401) {
          Message({
            message: "身份信息已过期，请重新登录",
            type: 'error',
            duration: 2 * 1000,
            offset: 400,
          })
          setTimeout(() => {
            location.href = `/login?redirect=${location.pathname}`
          }, 1000);
          return
        }
        Message({
          message: res.error || 'Error',
          type: 'error',
          duration: 2 * 1000
        })
        /*  return Promise.reject(new Error(res.error || 'Error')) */
        return res.error

      }
    } else {
      Message({
        message: 'Error',
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject(new Error('Error'))
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service //导出封装后的axios
